import React, { useState, useMemo } from 'react';
import {
  Button,
  Tooltip,
  Input,
  Select,
  Popover,
  Typography,
  Menu,
  Dropdown,
} from 'antd';
import {
  DeleteOutlined,
  PlusOutlined,
  CheckOutlined,
  CloseOutlined,
  DownOutlined,
} from '@ant-design/icons';
import { BsPencilSquare } from 'react-icons/bs';
import { Resizable } from 'react-resizable';
import 'react-resizable/css/styles.css';
import UserAvatar from '../../../../components/userAvatar';
import './Backlog.css';
import httpInjectorService from 'services/http-injector.service';
import { toast } from 'react-toastify';
import './SubtaskDetailModal';
import SubtaskDetailModal from './SubtaskDetailModal';
import { SquareCheck } from 'lucide-react';
//import Subtask16Icon from './artifacts/glyph/subtask/16';
import SubtaskObject from '@atlaskit/object/subtask';

const TaskSubtaskSection = ({
  statusOptions,
  assigneeOptions,
  autoSave,
  fetchSubtaskData,
  subtasks,
  setSubTasks,
  projectId,
  handleAddNew,
  addingNew,
  setAddingNew,
  newSubtask,
  setNewSubtask,
  handleAddSubtask,
  onClose,
  setIsSubtaskModalOpen,
  setSelectedSubtask,
  handleSubtaskClick,
  getStatusColors,
  taskdata,
}) => {
  const [hoveredKey, setHoveredKey] = useState(null);
  const [editingKey, setEditingKey] = useState(null);
  const [editedTitle, setEditedTitle] = useState('');

  // const [isSubtaskModalOpen, setIsSubtaskModalOpen] = useState(false);
  // const [selectedsubtask, setSelectedSubtask] = useState(null);

  const priorityOptions = ['High', 'Medium', 'Low'];
  const { Text } = Typography;

  const handleSaveTitle = async (record) => {
    const updatedTitle = editedTitle.trim();
    if (!updatedTitle) return;

    const updatedRecord = { ...record, subtask_title: updatedTitle };

    setSubTasks((prev) =>
      prev.map((item) =>
        item.subtask_key === record.subtask_key ? updatedRecord : item,
      ),
    );

    setEditingKey(null);

    try {
      await saveSubtask(
        updatedRecord.subtask_id || updatedRecord.subtask_key,
        updatedRecord,
      );
    } catch (err) {
      console.error('Failed to update title:', err);
    }
  };

  const [colWidths, setColWidths] = useState({
    key: 70,
    work: 200,
    priority: 100,
    assignee: 80,
    status: 100,
    action: 80,
  });

  const handleResize = (col, newWidth) => {
    setColWidths((prev) => ({
      ...prev,
      [col]: Math.max(newWidth, 60),
    }));
  };

  const saveSubtask = async (subtaskId, updatedData = {}) => {
    const existing = subtasks.find(
      (t) => t.subtask_id === subtaskId || t.subtask_key === subtaskId,
    );

    if (!existing) {
      console.error('Subtask not found for update');
      return;
    }

    const normalizedExisting = {
      subtask_id: existing.subtask_id || subtaskId,
      subtask_title: existing.subtask_title || existing.title || '',
      subtask_status: existing.subtask_status || existing.status || 'To Do',
      subtask_priority:
        existing.subtask_priority || existing.priority || 'Medium',
      subtask_assignee_id:
        existing.subtask_assignee_id ||
        existing.assignee_id ||
        existing.assignee ||
        null,
    };

    const merged = { ...normalizedExisting, ...updatedData };

    const reqBody = {
      project_id: projectId,
      subtask_id: merged.subtask_id,
      title: merged.subtask_title,
      subtask_status: merged.subtask_status,
      subtask_priority: merged.subtask_priority,
      subtask_assignee_id: merged.subtask_assignee_id,
      work_item_url: `${window.location.origin}/admin/taskBoard/${projectId}/subtaskDetails/${merged.subtask_id}`,
    };

    try {
      const response = await httpInjectorService.updateSubtask(reqBody);
      if (response.status === 'success') {
        fetchSubtaskData();
      } else {
        console.warn('Update API did not return success:', response);
      }
    } catch (error) {
      console.error('Error saving subtask:', error);
    }
  };

  const deleteChildTask = async (subtaskId, subtaskkey) => {
    try {
      const reqbody = {
        project_id: projectId,
        subtask_ids: [subtaskId],
      };
      const response = await httpInjectorService.delete_subtask(reqbody);

      if (response.status === 'success') {
        toast.success(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
        setSubTasks((prev) =>
          prev.filter((item) => item.subtask_key !== subtaskId),
        );
        fetchSubtaskData();
      } else {
        toast.error(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.error('Error deleting child task:', error);
    }
  };

  //   const currentSubtaskStatus = record.subtask_status || record.status;
  // const colors = getStatusColors(currentSubtaskStatus);

  const subtaskCount = taskdata?.subtask_status_count?.subtask_count;

  const subtaskCounts = useMemo(() => {
    if (!Array.isArray(subtasks) || subtasks.length === 0) {
      return null;
    }

    const counts = { subtask_count: subtasks.length };

    subtasks.forEach((s) => {
      const status = s.status || 'TO DO';
      counts[status] = (counts[status] || 0) + 1;
    });

    return counts;
  }, [subtasks]);

  return (
    <>
      <div>
        {/* Add new subtask button */}
        {/* <Button
        icon={<PlusOutlined />}
        type="default"
        style={{
          borderRadius: 20,
          fontWeight: 600,
          border: '1px solid #d9d9d9',
          background: '#fff',
          display: 'flex',
          alignItems: 'center',
        }}
        onClick={() => setAddingNew(!addingNew)}
      >
        Add Subtask
      </Button> */}

        {subtaskCounts?.subtask_count > 0 &&
          (() => {
            const counts = subtaskCounts;

            const total = Number(counts?.subtask_count || 0) || 1;

            const todo = Number(counts['TO DO'] || 0);
            const done = Number(counts['DONE'] || 0);

            let blue = 0;
            let blueInfo = [];

            Object.keys(counts).forEach((key) => {
              if (!['TO DO', 'DONE', 'subtask_count'].includes(key)) {
                const v = Number(counts[key] || 0);
                blue += v;
                blueInfo.push(`${key}: ${v} of ${total}`);
              }
            });

            const donePercent = (done / total) * 100;
            const bluePercent = (blue / total) * 100;
            const todoPercent = (todo / total) * 100;

            return (
              <div style={{ marginBottom: '12px' }}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '16px',
                  }}
                >
                  <div
                    style={{
                      width: '100%',
                      height: '10px',
                      background: '#E2E8F0',
                      borderRadius: '8px',
                      overflow: 'hidden',
                      display: 'flex',
                    }}
                  >
                    {/* DONE  */}
                    {done > 0 && (
                      <Tooltip title={`DONE: ${done} of ${total}`}>
                        <div
                          style={{
                            width: `${donePercent}%`,
                            background: '#2EB67D',
                            cursor: 'pointer',
                            borderRadius: '8px',
                            marginRight: '2px',
                          }}
                        />
                      </Tooltip>
                    )}

                    {/* BLUE (In-progress / others) */}
                    {blue > 0 && (
                      <Tooltip title={blueInfo.join(', ')}>
                        <div
                          style={{
                            width: `${bluePercent}%`,
                            background: '#1E90FF',
                            cursor: 'pointer',
                            borderRadius: '8px',
                            marginRight: '2px',
                          }}
                        />
                      </Tooltip>
                    )}

                    {/* TO DO */}
                    {todo > 0 && (
                      <Tooltip title={`TO DO: ${todo} of ${total}`}>
                        <div
                          style={{
                            width: `${todoPercent}%`,
                            background: '#A0AEC0',
                            cursor: 'pointer',
                            borderRadius: '8px',
                          }}
                        />
                      </Tooltip>
                    )}
                  </div>

                  <div style={{ fontWeight: 600, whiteSpace: 'nowrap' }}>
                    Done: {Math.round(donePercent)}%
                  </div>
                </div>
              </div>
            );
          })()}
        {/* Custom resizable table */}
        {subtasks.length > 0 && (
          <div style={{ marginTop: 12, overflowX: 'auto' }}>
            <table
              style={{
                width: '100%',
                borderCollapse: 'collapse',
                border: '1px solid #f0f0f0',
                tableLayout: 'fixed',
              }}
            >
              <thead style={{ background: '#fafafa' }}>
                <tr>
                  {Object.entries({
                    key: '#',
                    work: 'Work',
                    priority: 'Priority',
                    assignee: 'Assignee',
                    status: 'Status',
                    //action: 'Action',
                  }).map(([key, title]) => (
                    <Resizable
                      key={key}
                      width={colWidths[key]}
                      height={0}
                      onResize={(e, { size }) => handleResize(key, size.width)}
                      draggableOpts={{ enableUserSelectHack: false }}
                    >
                      <th
                        style={{
                          width: colWidths[key],
                          borderBottom: '1px solid #f0f0f0',
                          padding: '8px 10px',
                          fontWeight: 600,
                          textAlign: 'left',
                          position: 'relative',
                          userSelect: 'none',
                        }}
                      >
                        {title}
                      </th>
                    </Resizable>
                  ))}
                </tr>
              </thead>

              <tbody>
                {subtasks.map((record) => {
                  const isHovered = hoveredKey === record.subtask_key;
                  const isEditing = editingKey === record.subtask_key;

                  return (
                    <tr
                      key={record.subtask_key}
                      onMouseEnter={() => setHoveredKey(record.subtask_key)}
                      onMouseLeave={() => setHoveredKey(null)}
                      style={{
                        borderBottom: '1px solid #f0f0f0',
                        transition: 'background 0.2s',
                        background: isHovered ? '#fafafa' : 'transparent',
                      }}
                    >
                      {/* # */}

                      <td
                        style={{
                          width: colWidths.key,
                          padding: '8px 10px',
                          color: 'blue',
                          cursor: 'pointer',
                        }}
                        onClick={() => {
                          setSelectedSubtask(record);
                          setIsSubtaskModalOpen(true);
                        }}
                      >
                        <SubtaskObject
                          size={18}
                          stroke="#0052CC"
                          fill="white"
                          strokeWidth={2}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            lineHeight: 1,
                          }}
                        />
                        {record.subtask_key}
                      </td>

                      {/* Work column */}
                      <td
                        style={{
                          width: colWidths.work,
                          padding: '8px 10px',
                          position: 'relative',
                          overflow: 'hidden',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {isEditing ? (
                          <Input
                            size="small"
                            value={editedTitle}
                            onChange={(e) => setEditedTitle(e.target.value)}
                            onBlur={() => handleSaveTitle(record)}
                            onPressEnter={() => handleSaveTitle(record)}
                            autoFocus
                          />
                        ) : (
                          <>
                            <Tooltip title={record.subtask_title}>
                              <span
                                style={{
                                  display: 'block',
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  maxWidth: 'calc(100% - 24px)',
                                }}
                              >
                                {record.subtask_title}
                              </span>
                            </Tooltip>

                            <BsPencilSquare
                              onClick={() => {
                                setEditingKey(record.subtask_key);
                                setEditedTitle(record.subtask_title);
                              }}
                              style={{
                                position: 'absolute',
                                right: 6,
                                top: '50%',
                                transform: 'translateY(-50%)',
                                cursor: 'pointer',
                                opacity: isHovered ? 1 : 0,
                                transition: 'opacity 0.2s',
                                color: '#595959',
                              }}
                            />
                          </>
                        )}
                      </td>

                      {/* Priority */}
                      <td
                        style={{
                          width: colWidths.priority,
                          padding: '8px 10px',
                        }}
                      >
                        <Select
                          size="small"
                          value={record.priority}
                          onChange={async (value) => {
                            setSubTasks((prev) =>
                              prev.map((item) =>
                                item.subtask_key === record.subtask_key
                                  ? { ...item, subtask_priority: value }
                                  : item,
                              ),
                            );
                            await saveSubtask(
                              record.subtask_id || record.subtask_key,
                              {
                                subtask_priority: value,
                              },
                            );
                          }}
                        >
                          {priorityOptions.map((p) => (
                            <Select.Option key={p} value={p}>
                              {p}
                            </Select.Option>
                          ))}
                        </Select>
                      </td>

                      {/* Assignee */}
                      <td
                        style={{
                          width: colWidths.assignee,
                          padding: '8px 10px',
                        }}
                      >
                        <Popover
                          placement="bottomLeft"
                          trigger="click"
                          overlayInnerStyle={{
                            width: 200,
                            maxHeight: 260,
                            overflowY: 'auto',
                            padding: 6,
                          }}
                          content={
                            assigneeOptions.length > 0 ? (
                              assigneeOptions.map((user) => (
                                <div
                                  key={user.user_id}
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 8,
                                    padding: '6px 10px',
                                    borderRadius: 6,
                                    cursor: 'pointer',
                                    background:
                                      record.assignee === user.user_id
                                        ? '#e6f4ff'
                                        : 'transparent',
                                    transition: 'background 0.2s',
                                  }}
                                  onClick={async () => {
                                    setSubTasks((prev) =>
                                      prev.map((item) =>
                                        item.subtask_key === record.subtask_key
                                          ? {
                                              ...item,
                                              subtask_assignee_id: user.user_id,
                                            }
                                          : item,
                                      ),
                                    );
                                    await saveSubtask(
                                      record.subtask_id || record.subtask_key,
                                      {
                                        subtask_assignee_id: user.user_id,
                                      },
                                    );
                                  }}
                                >
                                  <UserAvatar
                                    username={user.username}
                                    size={26}
                                  />
                                  <Text style={{ fontSize: 14 }}>
                                    {user.username}
                                  </Text>
                                </div>
                              ))
                            ) : (
                              <Text type="secondary">No employees found</Text>
                            )
                          }
                        >
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 8,
                              cursor: 'pointer',
                            }}
                          >
                            <UserAvatar
                              username={record.assignee_name || 'Unassigned'}
                              size={26}
                            />
                            {/* <Text style={{ fontSize: 14 }}>
                          {record.assignee_name || 'Unassigned'}
                        </Text> */}
                          </div>
                        </Popover>
                      </td>

                      {/* Status */}
                      <td
                        style={{
                          width: colWidths.status,
                          padding: '8px 10px',
                          overflow: 'hidden',
                        }}
                      >
                        {(() => {
                          const currentSubtaskStatus =
                            record.subtask_status || record.status;

                          const colors = getStatusColors(currentSubtaskStatus);

                          return (
                            <Tooltip title={currentSubtaskStatus}>
                              <Dropdown
                                overlay={
                                  <Menu>
                                    {statusOptions.map((s) => {
                                      const optColors = getStatusColors(
                                        s.status_name,
                                      );
                                      return (
                                        <Menu.Item
                                          key={s.status_name}
                                          onClick={async () => {
                                            setSubTasks((prev) =>
                                              prev.map((item) =>
                                                item.subtask_key ===
                                                record.subtask_key
                                                  ? {
                                                      ...item,
                                                      subtask_status:
                                                        s.status_name,
                                                    }
                                                  : item,
                                              ),
                                            );

                                            await saveSubtask(
                                              record.subtask_id ||
                                                record.subtask_key,
                                              { subtask_status: s.status_name },
                                            );
                                          }}
                                        >
                                          <span
                                            style={{
                                              backgroundColor: optColors.bg,
                                              color: optColors.color,
                                              fontWeight: 600,
                                              borderRadius: 16,
                                              padding: '3px 10px',
                                              fontSize: 12,
                                              display: 'inline-block',
                                              textTransform: 'uppercase',
                                            }}
                                          >
                                            {s.status_name}
                                          </span>
                                        </Menu.Item>
                                      );
                                    })}
                                  </Menu>
                                }
                                trigger={['click']}
                              >
                                <Button
                                  type="default"
                                  style={{
                                    borderRadius: 20,
                                    width: '100%',
                                    backgroundColor: colors.bg,
                                    color: colors.color,
                                    fontWeight: 600,
                                    border: '1px solid rgba(56, 112, 190, 1)',
                                    textTransform: 'uppercase',
                                    fontSize: 12,
                                    padding: '2px 14px',
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}
                                >
                                  <span
                                    style={{
                                      flex: 1,
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                    }}
                                  >
                                    {currentSubtaskStatus}
                                  </span>
                                  {/* <DownOutlined
                                    style={{
                                      fontSize: 10,
                                      marginLeft: 6,
                                      flexShrink: 0,
                                    }}
                                  /> */}
                                </Button>
                              </Dropdown>
                            </Tooltip>
                          );
                        })()}
                      </td>

                      {/* Action */}
                      <td
                        style={{ width: colWidths.action, padding: '8px 10px' }}
                      >
                        <Button
                          icon={<DeleteOutlined />}
                          size="small"
                          type="text"
                          danger
                          onClick={() =>
                            deleteChildTask(
                              record.subtask_id,
                              record.subtask_key,
                            )
                          }
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}

        {/* New subtask input */}
        {addingNew && (
          <div
            style={{
              display: 'flex',
              gap: 8,
              marginTop: 10,
              alignItems: 'center',
            }}
          >
            <Input
              placeholder="What needs to be done?"
              size="small"
              value={newSubtask.subtask_title}
              onChange={(e) =>
                setNewSubtask({ ...newSubtask, subtask_title: e.target.value })
              }
            />

            <Button
              // icon={<CheckOutlined />}
              type="text"
              style={{ color: '#fff', background: 'blue' }}
              onClick={handleAddSubtask}
            >
              Add
            </Button>
            <Button
              icon={<CloseOutlined />}
              type="text"
              style={{ color: 'red' }}
              onClick={() => setAddingNew(false)}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default TaskSubtaskSection;
